import {
  FETCHING_ALL_CHAT_USERS_REQUEST,
  FETCHING_ALL_CHAT_USERS_SUCCEEDED,
  FETCHING_ALL_CHAT_USERS_FAILED,
  FETCHING_CHAT_USER_REQUEST,
  FETCHING_CHAT_USER_SUCCEEDED,
  FETCHING_CHAT_USER_FAILED,
  ASSOCIATE_CHAT_USER_REQUEST,
  ASSOCIATING_CHAT_USER_SUCCEEDED,
  ASSOCIATING_CHAT_USER_FAILED,
  SEND_MESSAGE_AS_EMAIL,
  SEND_MESSAGE_AS_EMAIL_SUCCEEDED,
  SEND_MESSAGE_AS_EMAIL_FAILED,
  FETCHING_NUDGES_REQUEST,
  FETCHING_NUDGES_SUCCEEDED,
  FETCHING_NUDGES_FAILED,
  FETCHING_LOCATIONS_FOR_CHAT_USERS_REQUEST,
  FETCHING_LOCATIONS_FOR_CHAT_USERS_SUCCEEDED,
  FETCHING_LOCATIONS_FOR_CHAT_USERS_FAILED,
  UPDATING_UNREAD_FOR_CHAT_USER_REQUEST,
  UPDATING_UNREAD_FOR_CHAT_USER_SUCCEEDED,
  UPDATING_UNREAD_FOR_CHAT_USER_FAILED,
  FETCH_CURRENTLY_VIEWING_ASSET,
  FETCH_CURRENTLY_VIEWING_ASSET_SUCCEEDED,
  FETCH_CURRENTLY_VIEWING_ASSET_FAILED,
  INVALIDATE_LIVE_VIEW_DATA,
  BLOCK_CHAT_USER,
  BLOCK_CHAT_USER_SUCCEEDED,
  BLOCK_CHAT_USER_FAILED,
} from "./actionTypes.jsx";

import axios from "axios";
import buildUrl from "build-url-ts";
const apiUrl = `${process.env.REACT_APP_API_URL}`;

const CHAT_USERS_BASE_URL = `${apiUrl}/api/2.0/chat_users`;

/*
 * FETCH CHAT USERS
 */
export function fetchChatUsers(page, filter, global) {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_ALL_CHAT_USERS_REQUEST));

    let url = buildUrl(CHAT_USERS_BASE_URL, {
      path: `/all`,
      queryParams: {
        page: page,
        filter: filter,
        global: global,
      },
    });

    return axios({
      method: "GET",
      url: url,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(
            FETCHING_ALL_CHAT_USERS_SUCCEEDED,
            response.data,
          ),
        ),
      )
      .catch((error) =>
        dispatch(fetchingFailedAction(FETCHING_ALL_CHAT_USERS_FAILED, error)),
      );
  };
}

/*
 * FETCH CHAT USER
 */
export function fetchChatUser(id) {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_CHAT_USER_REQUEST));

    return axios({
      method: "GET",
      url: `${CHAT_USERS_BASE_URL}/${id}`,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(FETCHING_CHAT_USER_SUCCEEDED, response.data),
        ),
      )
      .catch((error) =>
        dispatch(fetchingFailedAction(FETCHING_CHAT_USER_FAILED, error)),
      );
  };
}

/*
 * ASSOCIATE CHAT USER
 */
export function associateChatUser(chatUserId, uuid) {
  return function (dispatch) {
    dispatch(fetchingAction(ASSOCIATE_CHAT_USER_REQUEST));

    const params = {
      uuid: uuid,
    };

    return axios({
      method: "PUT",
      url: `${CHAT_USERS_BASE_URL}/${chatUserId}/associate`,
      params: params,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(
            ASSOCIATING_CHAT_USER_SUCCEEDED,
            response.data,
          ),
        ),
      )
      .catch((error) =>
        dispatch(fetchingFailedAction(ASSOCIATING_CHAT_USER_FAILED, error)),
      );
  };
}

/*
 * SEND MESSAGE AS EMAIL
 */
export function sendMessageAsEmail(chatUserId, message) {
  return function (dispatch) {
    dispatch(fetchingAction(SEND_MESSAGE_AS_EMAIL));

    const params = {
      message: message,
    };

    return axios({
      method: "PUT",
      url: `${CHAT_USERS_BASE_URL}/${chatUserId}/email`,
      params: params,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(
            SEND_MESSAGE_AS_EMAIL_SUCCEEDED,
            response.data,
          ),
        ),
      )
      .catch((error) =>
        dispatch(fetchingFailedAction(SEND_MESSAGE_AS_EMAIL_FAILED, error)),
      );
  };
}

/*
 * FETCH NUDGES
 */
export function fetchNudges() {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_NUDGES_REQUEST));

    let url = buildUrl(CHAT_USERS_BASE_URL, {
      path: `/nudges`,
    });

    return axios({
      method: "GET",
      url: url,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(FETCHING_NUDGES_SUCCEEDED, response.data),
        ),
      )
      .catch((error) =>
        dispatch(fetchingFailedAction(FETCHING_NUDGES_FAILED, error)),
      );
  };
}

/*
 * FETCH Locations for given filter
 */
export function fetchLocationsChatUsers(filter, global) {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_LOCATIONS_FOR_CHAT_USERS_REQUEST));

    let url = buildUrl(CHAT_USERS_BASE_URL, {
      path: `/locations`,
      queryParams: {
        filter: filter,
        global: global,
      },
    });

    return axios({
      method: "GET",
      url: url,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(
            FETCHING_LOCATIONS_FOR_CHAT_USERS_SUCCEEDED,
            response.data,
          ),
        ),
      )
      .catch((error) =>
        dispatch(
          fetchingFailedAction(FETCHING_LOCATIONS_FOR_CHAT_USERS_FAILED, error),
        ),
      );
  };
}

/*
 * Update unread
 */
export function updateUnreadForChatUser(uuid) {
  return function (dispatch) {
    dispatch(fetchingAction(UPDATING_UNREAD_FOR_CHAT_USER_REQUEST));

    const params = {
      uuid: uuid,
      unread: false,
    };

    return axios({
      method: "PUT",
      url: `${CHAT_USERS_BASE_URL}/unread`,
      params: params,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(
            UPDATING_UNREAD_FOR_CHAT_USER_SUCCEEDED,
            response.data,
          ),
        ),
      )
      .catch((error) =>
        dispatch(
          fetchingFailedAction(UPDATING_UNREAD_FOR_CHAT_USER_FAILED, error),
        ),
      );
  };
}

/*
 * Block chat user
 */
export function blockChatUser(chatUserId, blocked) {
  return function (dispatch) {
    dispatch(fetchingAction(BLOCK_CHAT_USER));

    const params = {
      blocked: blocked,
    };

    return axios({
      method: "PUT",
      url: `${CHAT_USERS_BASE_URL}/${chatUserId}/block`,
      params: params,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(BLOCK_CHAT_USER_SUCCEEDED, response.data),
        ),
      )
      .catch((error) =>
        dispatch(fetchingFailedAction(BLOCK_CHAT_USER_FAILED, error)),
      );
  };
}

/*
 * Fetch Currently Viewing Asset
 */
export function fetchCurrentlyViewingAsset(chatUserId) {
  return function (dispatch) {
    dispatch(fetchingAction(FETCH_CURRENTLY_VIEWING_ASSET));

    return axios({
      method: "GET",
      url: `${CHAT_USERS_BASE_URL}/${chatUserId}/analytics`,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(
            FETCH_CURRENTLY_VIEWING_ASSET_SUCCEEDED,
            response.data,
          ),
        ),
      )
      .catch((error) =>
        dispatch(
          fetchingFailedAction(FETCH_CURRENTLY_VIEWING_ASSET_FAILED, error),
        ),
      );
  };
}

/*
 * Invalidate Live View Data
 */
export function invalidateLiveViewData() {
  return function (dispatch) {
    dispatch(fetchingAction(INVALIDATE_LIVE_VIEW_DATA));
  };
}

/*
 * Common functions
 */
function fetchingAction(type) {
  return {
    type: type,
    payload: {},
  };
}

function fetchingSucceededAction(type, json) {
  return {
    type: type,
    payload: json,
  };
}

function fetchingFailedAction(type, error) {
  return {
    type: type,
    payload: {
      error: error,
    },
  };
}
